export default __webpack_public_path__ + "static/benefitBgImage-39c92d7a94324fb52d0a1af4678e104e.png";